import React, { useState, useEffect, useCallback } from 'react'
import { TextField, InputAdornment, IconButton } from '@material-ui/core'
import { Search as SearchIcon, Clear as ClearIcon } from '@material-ui/icons'
import { useTrans } from '../../../services/i18n'
import { CONTAINS } from '../../../constants/filter'
import connect from '../connect'

const FormNameFilter = ({ filters, onChangeFilters }) => {
  const { trans } = useTrans()
  const [searchValue, setSearchValue] = useState('')

  // Debounce function
  const debounce = useCallback((func, wait) => {
    let timeout
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout)
        func(...args)
      }
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
    }
  }, [])

  // Debounced filter update function
  const debouncedUpdateFilter = useCallback(
    debounce((value) => {
      onChangeFilters({
        formName: {
          type: CONTAINS,
          value: value.trim(),
        },
      })
    }, 500),
    [onChangeFilters]
  )

  // Initialize from filters
  useEffect(() => {
    const currentValue = filters?.fields?.formName?.value || ''
    setSearchValue(currentValue)
  }, [filters?.fields?.formName?.value])

  const handleInputChange = (event) => {
    const newValue = event.target.value
    setSearchValue(newValue)
    // Automatically trigger debounced search
    debouncedUpdateFilter(newValue)
  }

  const handleClear = () => {
    setSearchValue('')
    onChangeFilters({
      formName: {
        type: CONTAINS,
        value: '',
      },
    })
  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      // Cancel debounce and immediately update
      debouncedUpdateFilter.cancel?.()
      onChangeFilters({
        formName: {
          type: CONTAINS,
          value: searchValue.trim(),
        },
      })
    }
  }

  return (
    <TextField
      variant="outlined"
      size="small"
      placeholder={trans('search-form-name')}
      value={searchValue}
      onChange={handleInputChange}
      onKeyPress={handleKeyPress}
      style={{ width: '100%', maxWidth: 400 }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon color="action" />
          </InputAdornment>
        ),
        endAdornment: searchValue && (
          <InputAdornment position="end">
            <IconButton size="small" onClick={handleClear}>
              <ClearIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  )
}

export default connect(FormNameFilter)